export enum NFLTeamAbbreviation {
    NFL = 'nfl',
    ARI = 'ari',
    ATL = 'atl',
    BAL = 'bal',
    BUF = 'buf',
    CAR = 'car',
    CHI = 'chi',
    CIN = 'cin',
    CLE = 'cle',
    DAL = 'dal',
    DEN = 'den',
    DET = 'det',
    GB = 'gb',
    HOU = 'hou',
    IND = 'ind',
    JAX = 'jax',
    KC = 'kc',
    LA = 'la',
    LAC = 'lac',
    LV = 'lv',
    MIA = 'mia',
    MIN = 'min',
    NE = 'ne',
    NO = 'no',
    NYG = 'nyg',
    NYJ = 'nyj',
    PHI = 'phi',
    PIT = 'pit',
    SEA = 'sea',
    SF = 'sf',
    TB = 'tb',
    TEN = 'ten',
    WAS = 'was',
    DEFAULT = '',
}
